// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import Breadcrumbs from '@/components/breadcrumbs';
import { colors, layout } from '@/theme';
import Router from 'next/router';
import Fetch from '@/utils/Fetch';
import ToastContext from '@/utils/toast-context';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import ReportFilterInput from '@/components/report/report-filter-input';
import ButtonDropdown from '@/components/button-dropdown';
import Time from '@/utils/time';
import DownloadService from '@/utils/download-service';
import StoreService from '@/services/store/store-service';
import Storage from '@/utils/storage';
import ConfirmAction from '@/components/modals/confirm-action';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'



function ReportList() {
  const toast = useContext(ToastContext);

  const getReportModules = (reps: any) => {
    let moduleNames = [];
    reps.map(function (report: any) {
      let mod = Enums.getEnumStringValue(Enums.Module, report.Module);
      if (moduleNames.indexOf(((mod as any) as any)) === -1) {
        moduleNames.push(((mod as any) as any));
      }
    });
    return moduleNames.sort(Helper.sortAscending);
  };

  const [isMultiStore, setIsMultiStore] = useState(false);
  const [reports, setReports] = useState<any[]>([]);
  const [moduleReports, setModuleReports] = useState<any[]>([]);
  const [selectedReport, setSelectedReport] = useState<any>(null);
  const [selectedReportModule, setSelectedReportModule] = useState<any>(null);
  const [reportConfigTemplates, setReportConfigTemplates] = useState<any[]>([]);
  const [reportModules, setReportModules] = useState<any[]>([]);
  const [isGenerating, setIsGenerating] = useState(false);
  const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());

  const { data: reportsData } = useQuery(
    ['reports'],
    () => Fetch.get({ url: '/Report', params: null })
  );

  useEffect(() => {
    if (reportsData) {
      const filtered = reportsData.Results.filter((res: any) =>
        res.Module !== Enums.Module.Collection && res.Module !== Enums.Module.Document
      );
      setReports(filtered);
      setReportModules(getReportModules(filtered));
    }
  }, [reportsData]);

  const [filterInputs, setFilterInputs] = useState<any>({});

  const [onlyExcelExport, setOnlyExcelExport] = useState(false);

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  }

  useEffect(() => {
    getAccessStatus();

    StoreService.isMultiStore().then((ims: any) => {
      setIsMultiStore(ims);
    });

  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);


  const updateSelectedReportModule = (module: any) => {
    setSelectedReportModule(module);
    updateSelectedReport(null);
  };

  const updateSelectedReport = (report: any) => {
    setSelectedReport(report);
  };

  const defaultStartDate = Time.toISOString(Time.addDays(-7, Time.today()));
  const defaultEndDate = Time.today();

  useEffect(() => {
    let reps = [];
    reps = reports.filter(function (report: any) {
      return Enums.getEnumStringValue(Enums.Module, report.Module) === selectedReportModule;
    }).sort(Helper.sortAscending);
    setModuleReports(reps);
  }, [selectedReportModule]);

  useEffect(() => {
    let inps = selectedReport && selectedReport.DateRequired === true ? {
      StartDate: filterInputs.StartDate || defaultStartDate,
      EndDate: filterInputs.EndDate || defaultEndDate
    } : {};
    setFilterInputs(inps);
    setReportConfigTemplates([]);

    if (!selectedReport) return;
    const getReportConfigTemplates = async (report: any) => {
      let request = await Fetch.get({
        url: "/Report/GetReportConfigTemplates",
        params: {
          reportID: report.ID
        }
      });

      let templates = request.Results;

      if (!isMultiStore) {
        templates = templates.filter((x: any) => x.Name != "Store");
      }

      setReportConfigTemplates(templates);
      templates.map(function (res: any) {
        inps[res.Name] = res.DefaultValue;
      });
      setFilterInputs(inps);
    };

    getReportConfigTemplates(selectedReport);

    setOnlyExcelExport(selectedReport.ReportGenerator !== Enums.ReportGenerator.RDLC);
  }, [selectedReport]);

  const updateFilterInputs = (name: any, val: any) => {
    setFilterInputs((p: any) => ({
      ...p,
      [name]: val
    }))
  };

  const exportReport = (type: any) => {

    for (let temp of reportConfigTemplates) {
      if (temp.IsRequired && !filterInputs[temp.Name]) {
        toast.setToast!!!({
          message: "Required fields have not been filled in",
          show: true,
          type: Enums.ToastType.error
        });
        return;
      }
    }

    setIsGenerating(true);
    DownloadService.downloadFile("POST", "/Report/Export", { Filters: filterInputs, ReportID: selectedReport.ID, ExportType: type }, undefined, undefined, "", "", null, false, () => {
      setIsGenerating(false);
    });
  };

  Helper.preventRouteChangeGeneric(() => isGenerating, () => !isGenerating,
    "Report is generating",
    "Are you sure you want to navigate away? The report could take a bit of time to generate.",
    setConfirmOptions);

  return (
    <>
      <div className="manage-container">
        <div className="row">
          <div className="title">
            <Breadcrumbs currPage={{ text: 'Report List', link: '/report/list', type: 'list' }} />
          </div>
        </div>
        {reports && reports.length > 0 ? <>
          <h4>Export your reports by selecting from the list and setting filters if necessary</h4>
          <div className="row row-compact">

            <div className="menu">
              {reportModules.map(function (module: any, index: any) {
                return (
                  <div key={index} className={"link" + (module === selectedReportModule ? " current" : "")} onClick={() => updateSelectedReportModule(module)}>{module === 'JobCard' ? 'Job' : module}</div>
                )
              })}
            </div>

            {selectedReportModule ? <>
              <div className="menu width300">
                {moduleReports.map(function (report: any, index: any) {
                  return (
                    <div key={index} className={"link" + (report === selectedReport ? " current" : "")} onClick={() => updateSelectedReport(report)}>{report.ReportName}</div>
                  )
                })}
              </div>
            </> : <></>}

            <div className="card" style={{ width: "500px" }}>
              {selectedReport ? <>
                <div>
                  <h4>Export {selectedReport.ReportName}</h4>
                </div>
                <>

                  <div>
                    {reportConfigTemplates.length > 0 && reportConfigTemplates.sort(Helper.sortAscending).map(function (template: any, key: any) {
                      return (
                        <div key={key}>
                          <ReportFilterInput template={template} updateValue={updateFilterInputs} queryType={filterInputs.QueryType} />
                        </div>
                      )
                    })}

                    {selectedReport.DateRequired === true ? <>
                      <div className="row">
                        {/* Not actually required, just visible */}
                        <ReportFilterInput
                          key={"startDate"}
                          template={{
                            Name: "StartDate",
                            DefaultValue: defaultStartDate,
                            InputType: "date",
                            DataType: "string"
                          }} updateValue={updateFilterInputs} />
                        <ReportFilterInput
                          key={"endDate"}
                          template={{
                            Name: "EndDate",
                            DefaultValue: defaultEndDate,
                            InputType: "date",
                            DataType: "string"
                          }} updateValue={updateFilterInputs}
                          startDate={filterInputs.StartDate}
                        />
                      </div>
                    </> : <></>}
                  </div>
                </>

              </> : <></>}
            </div>
            <div>
              {selectedReport ? <>

                <div style={{ width: 120 }}>
                  <ButtonDropdown
                    action={exportReport}
                    text="Export"
                    disabled={isGenerating}
                    isBusy={isGenerating}
                    options={
                      selectedReport.ReportGenerator === Enums.ReportGenerator.RDLC ?
                        [
                          { text: 'Excel', link: Enums.ExportType.Excel },
                          { text: 'PDF', link: Enums.ExportType.PDF },
                          { text: 'Word', link: Enums.ExportType.Word },
                        ]
                        :
                      selectedReport.ReportGenerator === Enums.ReportGenerator.ExcelPDF ?
                        [
                          { text: 'Excel', link: Enums.ExportType.Excel },
                          { text: 'PDF', link: Enums.ExportType.PDF },
                        ]
                        :
                        [
                          { text: 'Excel', link: Enums.ExportType.Excel }
                        ]}
                  />
                </div>
                <br/>
              </> : <></>}
            </div>


          </div>
        </> : <div className="no-reports">
          <img src="/job-folder.svg" alt="Report List" />
          <h3>No reports found</h3>
          <p>You have no reports configured for your user account.</p>
        </div>}
      </div>

      <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />

      <style jsx>{`

.no-reports {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  justify-content: center;
  position: relative;
  text-align: center;
}

            .width100 {
                width: 100%;
            }            
            .column {
              width: 100%;
            }
            .column-margin {
              margin-left: 24px;
            }
            .button-container {
              flex-shrink: 0;
              width: 9rem;
            }
            .button-container :global(.button){
              margin-top: 0.5rem;
            }
            .title {
              align-items: center;
              display: flex;
              color: ${colors.darkPrimary};
              width: 100%;
            }
            .title h1 {
              font-size: 24px;
              margin: 6px 0 0 0;
            }
            .title p {
              font-size: 14px;
              margin: 0;
            }
            .row {
              display: flex;
              justify-content: space-between;
            }
            .row-compact {
              justify-content: start;
            }
            .end {
              align-items: flex-end;
            }
            .padded {
              padding-bottom: 1rem;
            }
            .row.top-gap {
              margin-top: 2.5rem;
            }
            .heading {
              color: ${colors.blueGrey};
              font-size: 14px;
              margin-bottom: 0.5rem;
            }
            .heading-blue {
              color: ${colors.bluePrimary};
            }
            .no-jobs {
              align-items: center;
              box-sizing: border-box;
              display: none;
              flex-direction: column;
              flex-grow: 1;
              height: 100%;
              justify-content: center;
              position: relative;
              text-align: center;
            }
            .no-jobs-visible {
              display: flex;
            }
            .no-jobs h3 {
              color: ${colors.darkPrimary};
              font-size: 18px;
              line-height: 22px;
              margin: 2rem 0 0;
            }
            .no-jobs p {
              color: ${colors.blueGrey};
              margin: 0.5rem 0 0;
            }
            .no-jobs a {
              align-items: center;
              color: ${colors.bluePrimary};
              cursor: pointer;
              display: flex;
              font-weight: bold;
              margin-top: 1rem;
              text-decoration: none;
            }
            .no-jobs a img {
              margin-right: 0.5rem;
            }
            .search-container :global(.search) {
              width: 528px;
            }
            a {
              text-decoration: none;
            }
            .select-actions {
              display: flex;
              margin-left: -1rem;
            }
            .select-actions :global(.white-action) {
              font-size: 0.875rem;
              margin: 0 0 0 1rem; 
              width: auto;
            }
            .select-actions :global(.icon) {
              left: 1rem !important;
            }
            .download {
              margin-right: 1rem;
              width: 3rem;
            }

            .card {
              background-color: ${colors.white};
              border-radius: ${layout.cardRadius};
              height: fit-content;
              padding: 0.5rem 0.5rem;
              margin-right: 8px;
              margin-top: 8px;
              min-height: 288px;
              box-shadow: 0px 8px 16px 0px rgba(51,51,51,0.1);
            }

            .menu {
                background-color: ${colors.white};
                border-radius: ${layout.cardRadius};
                box-sizing: border-box;
                flex-shrink: 0;
                height: fit-content;
                margin-right: 8px;
                margin-top: 8px;
                padding: 0.5rem 0.5rem;
                width: 150px;
                min-height: 288px;
                box-shadow: 0px 8px 16px 0px rgba(51,51,51,0.1);
              }
              .menu.width300 {
                  width: 300px;
              }
              .link {
                border-radius: ${layout.buttonRadius};
                box-sizing: border-box;
                color: ${colors.darkPrimary};
                cursor: pointer;
                display: flex;
                padding: 0.5rem;
                text-decoration: none;
                width: 100%;
              }
              .link:hover {
                background-color: ${colors.backgroundGrey};
              }
              .current {
                background-color: ${colors.backgroundGrey};
              }
              .nonlink {
                border-radius: ${layout.buttonRadius};
                box-sizing: border-box;
                color: ${colors.darkPrimary};
                display: flex;
                padding: 0.5rem;
                text-decoration: none;
                width: 100%;
                font-weight: bold;
              }
          `}</style>
    </>
  );
}

export default ReportList;

export const Route = createFileRoute('/_authenticated/report/list')({ component: ReportList })
